import 'bootstrap/dist/css/bootstrap.min.css';
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "./theme"; // ✅ Import the custom theme

import Layout from "./Components/Layout";
import LVCC from './Components/Pages/LVCC';
import Blocks from "./Components/Pages/Blocks";
import APIDocs from "./Components/Pages/APIDocs";
import Reports from "./Components/Pages/Reports";
import Experimental from "./Components/Pages/Experimental";
import Vitros from './Components/Pages/Vitros';
import G06 from './Components/Pages/G06';
import Workflow from './Components/Pages/Workflow';

function App() {
  return (
    <ThemeProvider theme={theme}> {/* ✅ Wrap app with ThemeProvider */}
      <CssBaseline /> {/* ✅ Normalizes styles for consistent look */}
      <Router>
        <Routes>
          {/* Layout wraps all pages and uses <Outlet> */}
          <Route path="/" element={<Layout />}>
            <Route index element={<LVCC />} />
            <Route path="blocks" element={<Blocks />} />
            <Route path="lvcc" element={<LVCC />} />
            <Route path="vitros" element={<Vitros />} />
            <Route path="Workflow" element={<Workflow />} />
            <Route path="G06" element={<G06 />} />
            <Route path="api-docs" element={<APIDocs />} />
            <Route path="reports" element={<Reports />} />
            <Route path="experimental" element={<Experimental />} />
          </Route>
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;